import React from 'react';
import mainContext from "../../../contexts/mainContext";
import { addBabySitterHappyWithController, deleteData, getBabySitterHappyWithController } from '../../../Controllers/AppManagement/babySitter';
import { __constants, __snackBarText, __snackBarSeverity } from '../../../constants';
import ImageTextListManager from '../common/ImageTextListManager';

export default function BabySitterHappyWith() {
  const { setProfileNavTitle } = React.useContext(mainContext);
  return (
    <ImageTextListManager
      navTitle="Babysitter help"
      dialogTitle="Add new happy with"
      textLabel="Happy with"
      getData={getBabySitterHappyWithController}
      addData={addBabySitterHappyWithController}
      deleteData={deleteData}
      editTitle="Update happy with"
      setProfileNavTitle={setProfileNavTitle}
      __constants={__constants}
      __snackBarText={__snackBarText}
      __snackBarSeverity={__snackBarSeverity}
      mainContext={mainContext}
    />
  );
}